export default __webpack_public_path__ + "static/media/h5-section1-bg4.0d1a118f.png";